import React from 'react';
import FourierVisualizer3D from './FourierVisualizer3D';
import './App.css';

function App() {
  return (
    <div className="App">
      <FourierVisualizer3D />
    </div>
  );
}

export default App;